import React, { useState } from "react";
import styles from "./AccordionList.module.sass";
import Accordion from "./Accordion/Accordion";

const AccordionList = ({ listItem }) => {
  const [contentArray, setContentArray] = useState(
    listItem.map(item => ({ ...item, show: false }))
  );

  const onClickShowItem = itemIndex => {
    const newContentArray = contentArray.map((item, index) => {
      const newItem = { ...item, show: false };
      if (itemIndex === index && !contentArray[itemIndex].show) {
        newItem.show = true;
      }
      return newItem;
    });
    setContentArray(newContentArray);
  };

  return (
    <ul className={styles.ListItem}>
      {contentArray.map((item, index) => {
        return (
          <li className={styles.Item} key={item.title}>
            <Accordion
              title={item.title}
              showContent={item.show}
              setShowContent={() => onClickShowItem(index)}
            >
              {item.content}
            </Accordion>
          </li>
        );
      })}
    </ul>
  );
};

export default AccordionList;
